<template>
  <div id="ChartScrollableStageDiv" :style="keyboardEventStore.clickMode == 1 ? 'cursor: cell' : 'cursor: default'">
    <EditorScrollableStage @moveY="moveY" @moveX="setPositionX">
      <v-layer :config="{
        listening: false,
        perfectDrawEnabled: false,
      }">
        <v-group>
          <EditorOfflineWaveform />
        </v-group>
        <v-group :config="{ x: chartPositionX, y: chartPositionY + chartRenderStore.hitPosY }">
          <EditorColumns />
          <ChartControlLine v-for="(cl, index) in orderedCL" :key="cl.eventLine.eventLineId" :clIndex="index" />
          <EditorEventLines />
        </v-group>
      </v-layer>
      <v-layer :config="{
        x: chartPositionX,
        y: chartPositionY + chartRenderStore.hitPosY,
        perfectDrawEnabled: false,
        listening: false,
        shadowForStrokeEnabled: false,
      }">
        <EditorNotes />
      </v-layer>
      <v-layer>
        <EditorUI @moveY="moveY" />
      </v-layer>
    </EditorScrollableStage>
  </div>
</template>

<script setup>
import EditorUI from '../editor/EditorUI.vue';
import { useAudioStore } from '../../stores/AudioStore.js';
import EditorNotes from '../editor/EditorNotes.vue';
import EditorOfflineWaveform from '../editor/EditorOfflineWaveform.vue';
import ChartControlLine from '../editor/EditorTimingLines.vue';
import { inject, provide, watch } from 'vue';
import { useChartRenderStore } from '../../stores/ChartRenderStore.js';
import { useKeyboardEventStore } from '../../stores/KeyboardEventStore.js';
import EditorEventLines from '../editor/EditorEventLines.vue';
import EditorScrollableStage from '../editor/EditorScrollableStage.vue';
import EditorColumns from '../editor/EditorColumns.vue';


const audioStore = useAudioStore()
const keyboardEventStore = useKeyboardEventStore()

const mainChart = inject('mainChart')
const mainChartRender = inject('mainChartRender')

provide('chart', mainChart)
provide('chartRender', mainChartRender)

const { orderedCL } = mainChart
const { chartPositionX, chartPositionY, setPositionX, currentTime } = mainChartRender

const chartRenderStore = useChartRenderStore()

watch(() => audioStore.hasAudioLoaded, () => {
  if (audioStore.hasAudioLoaded)
    mainChart.setDuration(audioStore.duration)
})
watch(() => audioStore.currentTime, () => {
  mainChartRender.currentTime.value = audioStore.currentTime
})

const moveY = time => {
  if (audioStore.hasAudioLoaded) {
    audioStore.seek(time)
  } else {
    currentTime.value = time
  }
}

</script>

<style>
#ChartScrollableStageDiv {
  border: outset #000000;
  overflow: hidden;
  height: fit-content;
  width: fit-content;
}
</style>